"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency["EUR"] = "EUR";
    Currency["CHF"] = "CHF";
    Currency["USD"] = "USD";
})(Currency = exports.Currency || (exports.Currency = {}));
